import React, { useState, useEffect } from "react";
import styled from "styled-components";

const NoResponseLabel = styled.label`
  display: flex;
  align-items: center;
  margin-top: 10px;
  width: 300px;
  height: 45px;
  background-color: white;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 1px 1px 0px;
  border: 2px solid transparent;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    span {
      color: #5bc5cd;
    }
  }

  input {
    position: relative;
    width: 25px;
    height: 25px;
    appearance: none;
    border: 2px solid #ace1e5;
    border-radius: 3px;
    background-color: white;
    margin-right: 10px;
    margin-left: 10px;
    cursor: pointer;

    &:checked {
      background-color: #5bc5cd;
      border: 2px solid #5bc5cd;

      &::before {
        content: "\\2714";
        position: absolute;
        top: -7px;
        left: 1px;
        font-size: 26px;
        color: white;
      }
    }

    &:hover {
      border-color: #5bc5cd;
    }
  }

  span {
    font-size: 16px;
    color: ${(props) => (props.checked ? "#5bc5cd" : "black")};
  }

  &.checked {
    background-color: #e6f6f7;
    border: 2px solid #5bc5cd;
  }
`;

const Checkbox = ({
  setDisabled,
  isOpen,
  selectedStates,
  setSelectedStates,
  index,
  label,
  currentPage,
  answeredQuestions,
  setAnsweredQuestions,
}) => {
  const [isChecked, setIsChecked] = useState(
    answeredQuestions[currentPage - 1][
      answeredQuestions[currentPage - 1]?.findIndex(
        (answer) => typeof answer === "object"
      )
    ]
      ? answeredQuestions[currentPage - 1][
          answeredQuestions[currentPage - 1]?.findIndex(
            (answer) => typeof answer === "object"
          )
        ][index]?.split("=")[1] === "1"
        ? true
        : false
      : false
  );

  useEffect(() => {
    isChecked ? setDisabled(true) : setDisabled(false);
  }, [isChecked]);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);

    if (isOpen) {
      let answeredQuestionsCopy = [...answeredQuestions];

      let openArrayIndex = answeredQuestionsCopy[currentPage - 1]?.findIndex(
        (answer) => typeof answer === "object"
      );

      let selectedStatesCopy = [...selectedStates];
      setSelectedStates(
        selectedStatesCopy.map((state, i) =>
          i !== index ? "" : isChecked ? "0" : "1"
        )
      );

      answeredQuestionsCopy[currentPage - 1][openArrayIndex] =
        answeredQuestionsCopy[currentPage - 1][openArrayIndex].map((ans, i) =>
          i === index
            ? `${ans.split("=")[0]}=${isChecked ? "0" : "1"}`
            : `${ans.split("=")[0]}=-998`
        );

      setAnsweredQuestions(answeredQuestionsCopy);
    }
  };

  return (
    <NoResponseLabel checked={isChecked} className={isChecked ? "checked" : ""}>
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleCheckboxChange}
      />
      <span>{label}</span>
    </NoResponseLabel>
  );
};

export default Checkbox;
